/**
 * Оверлей трансляции — хвост пути, а не префикс: его роут объявлен шаблоном
 * `organizer/:organizerId/device/:deviceId/overlay` (`Pages.OVERLAY_V2.INDEX`),
 * начало у него динамическое, поэтому из `Pages` берётся только смысл, а не строка.
 * Панель управления (`/control-panel`) сюда не входит: ею пользуется живой оператор.
 */
const OVERLAY_SUFFIX = '/overlay';

/**
 * Страницы, которые открывает не человек, а машина: аналитика и Session Replay пишут там мусор —
 * каждую отрисовку канвы, — поэтому инициализацию на них пропускаем. Раньше сюда входили и
 * headless-страницы рендера медиа-менеджера; рендер уехал на бэкенд (`POST /api/render-template`),
 * страниц больше нет, остался только OBS-источник трансляции.
 */
export function isHeadlessRoute(pathname: string): boolean {
  const normalized = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;

  return normalized.endsWith(OVERLAY_SUFFIX);
}
